<template>
  <v-container py-0 fluid>
    <Navbar
      :hasDrawer="true"
      :title="`Requisições (${requisicoes.length})`"
    >
      <template slot="actions">
        <v-btn
          icon
          :loading="loading"
          @click="getRequisicoes"
        ><v-icon>mdi-cached</v-icon>
        </v-btn>
        <v-btn
          icon
          :loading="syncLoading"
          @click="insertRequisicoesAPI"
        ><v-icon>mdi-database-sync</v-icon>
        </v-btn>
        <v-btn
          icon
          @click.stop="filterDrawer = !filterDrawer"
        ><v-icon>mdi-filter-variant</v-icon>
        </v-btn>
      </template>
    </Navbar>
    <v-navigation-drawer
      v-model="filterDrawer"
      absolute
      temporary
    >
      <h4 class="text-center py-3">Filtros</h4>
      <v-divider></v-divider>
      <v-container>
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-select
              dense
              v-model="orderSelected"
              hide-details
              label="Ordenar por"
              :items="orderItems"
            ></v-select>
          </v-col>
          <!-- <v-col cols="12" class="py-0">
            <v-subheader class="pl-0 font-weight-bold">Status</v-subheader>
            <v-checkbox
              v-model="statusSelected"
              label="Pendente"
              value="P"
              hide-details
              class="mt-0"
            ></v-checkbox>
            <v-checkbox
              v-model="statusSelected"
              label="Finalizado"
              value="F"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-divider></v-divider>
          </v-col> -->
          <v-col cols="12">
            <v-btn
              text
              @click.stop="filterDrawer = false"
            >Cancelar</v-btn>
            <v-btn
              color="primary"
              @click.stop="applyFilters"
            >Aplicar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-list
          v-if="requisicoes.length"
          class="pa-0"
          three-line
          :style="requisicoesContainer"
        >
          <v-list-item
            v-for="(requisicao, i) in requisicoesArray"
            :key="i"
            @click="$router.push(`/requisicoes/${requisicao.id_interno}`)"
            class="px-0"
          >
            <v-list-item-avatar :class="$vuetify.breakpoint.xs ? 'ma-auto' : ''">
              <StatusIcon :text="statusText(requisicao.id_requisicao)" :color="statusColor(requisicao.id_requisicao)" />
            </v-list-item-avatar>
            <v-list-item-content :class="i !== requisicoes.length -1 ? 'pb-0' : ''">
              <v-col cols="10" md="6" class="pa-0">
                <v-list-item-title class="font-weight-medium body-2">
                  <v-icon small>mdi-pound</v-icon>
                  {{ requisicao.id_requisicao ? `${requisicao.id_interno} (Cód. Externo: ${requisicao.id_requisicao})` : requisicao.id_interno }}
                </v-list-item-title>
              </v-col>
              <v-col cols="10" md="4" class="pa-0">
                <v-list-item-title class="font-weight-medium body-2">
                  <v-icon small>mdi-clipboard-text-outline</v-icon>
                  {{ typeText(requisicao.tipo) }}
                </v-list-item-title>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-list-item-title class="caption">
                  <v-icon small>mdi-calendar</v-icon>
                  {{ requisicao.data_emissao | dateTime }}
                </v-list-item-title>
              </v-col>
              <v-divider v-if="i !== requisicoes.length - 1" :key="i"></v-divider>
            </v-list-item-content>
            <v-list-item-action class="ma-auto">
              <v-btn icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <p v-else class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
        <p v-if="error" class="text-center font-weight-bold red--text mt-4 mb-0">{{ error }}</p>
        <div class="text-center mt-3" id="pagination">
          <v-pagination
            v-model="page"
            :length="totalPages"
            circle
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <!-- Button Create Pedido -->
    <v-fab-transition>
      <v-btn
        fixed
        fab
        dark
        bottom
        right
        color="primary"
        class="mb-11"
        @click="createAndEditRequisicao"
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import StatusIcon from '@/components/shared/StatusIcon';

export default {
  name: 'Requisicoes',
  components: {
    StatusIcon
  },
  data: () => ({
    filterDrawer: false,
    item: 1,
    page: 1,
    syncLoading: false,
    orderItems: ['id_interno', 'data_emissao'],
    orderSelected: 'id_interno',
    statusSelected: ['P'],
    filters: {
      order: 'id_interno',
      status: ['P']
    },
    error: ''
  }),
  computed: {
    ...mapGetters([
      'loading',
      'requisicoes',
      'permiteQtdeDivergente',
    ]),
    requisicoesContainer() {
      if (this.requisicoes.length) {
        const offset = 82;
        const bodyHeight = document.body.clientHeight;
        // const firstRowHeight = document.getElementById('first-row').clientHeight;
        const paginationDiv = document.getElementById('pagination');
        const paginationHeight = paginationDiv ? paginationDiv.clientHeight : 44;
        const barrasContainerHeight = bodyHeight - paginationHeight - offset;
        return {
          maxHeight: barrasContainerHeight.toString() + 'px',
          overflow: 'auto'
        }
      } else {
        return { maxHeight: 400 + 'px', overflow: 'auto' };
      }
    },
    requisicoesArray() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      return this.requisicoes
        .slice(start, end)
        .sort((a, b) => a[this.filters.order] > b[this.filters.order] ? 1 : -1);
        // .filter(item => this.filters.status.includes(item.status))
    },
    totalPages() {
      // const total = this.requisicoes
      //   .filter(item => this.filters.status.includes(item.status)).length / 10;
      const total = this.requisicoes.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  methods: {
    ...mapMutations(['SHOW_SNACKBAR']),
    ...mapActions(['fetchRequisicoes', 'createRequisicao', 'sendRequisicoesAPI']),
    async createAndEditRequisicao() {
      const idRequisicao = await this.createRequisicao({});
      this.$router.push({ name: 'Requisicao', params: { id: idRequisicao }});
    },
    statusText(idRequisicao) {
      if (idRequisicao) return 'mdi-checkbox-blank-circle';
      return 'mdi-checkbox-blank-circle-outline';
    },
    statusColor(idRequisicao) {
      if (idRequisicao) return 'success';
      return '';
    },
    typeText(type) {
      if (type && type.startsWith('T')) return 'Transferência';
      return 'Consumo';
    },
    loadLocalConfig() {
      const configRequisicoes = localStorage.getItem('configRequisicoes');
      if (configRequisicoes) {
        const { order } = JSON.parse(configRequisicoes);
        this.orderSelected = order;
        // this.statusSelected = status;
        this.filters.order = order;
        // this.filters.status = status;
      }
    },
    saveLocalConfig() {
      localStorage.setItem('configRequisicoes', JSON.stringify({
        order: this.orderSelected,
        // status: this.statusSelected
      }));
    },
    async insertRequisicoesAPI() {
      this.syncLoading = true;
      await this.sendRequisicoesAPI(this.requisicoes);
      this.syncLoading = false;
    },
    getRequisicoes() {
      this.fetchRequisicoes();
    },
    applyFilters() {
      this.filters.order = this.orderSelected;
      // this.filters.status = this.statusSelected;
      this.filterDrawer = false;
      this.saveLocalConfig();
    },
  },
  created() {
    this.loadLocalConfig();
    this.getRequisicoes();
  }
}
</script>
